import React from 'react';
import { CATEGORIES } from '../../constants';

function SearchAndFilter({ searchTerm, onSearchChange, selectedCategory, onCategoryChange }) {
    return (
        <div className="search-filter-container">
            <input
                type="text"
                placeholder="Search for person..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="search-input"
            />
            <div className="category-buttons">
                {['All', ...CATEGORIES].map(category => (
                    <button
                        key={category}
                        onClick={() => onCategoryChange(category)}
                        className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                    >
                        {category}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default SearchAndFilter;
